import React from "react";
import { T } from "../shared/UI";
import { useApp } from "../../store/AppContext";
import { useAuth } from "../../store/AuthContext";

const BASE_NAV = [
  { id:"map",     icon:"🗺",  label:"Live Map"    },
  { id:"agents",  icon:"👥",  label:"Agents"      },
  { id:"history", icon:"⏱",  label:"Play History" },
  { id:"visits-map", icon:"📍", label:"Visits Map" },
  { id:"reports", icon:"📊", label:"Reports"      },
  { id:"agent-attendance", icon:"📋", label:"Agent Attendance" },
];
const PRODUCTS_NAV = { id:"products", icon:"📦", label:"Products" };
const USERS_NAV = { id:"users", icon:"🧑‍💼", label:"Users" };
const APP_ALERTS_NAV = { id:"app-alerts", icon:"📲", label:"App Alerts" };
const GEOFENCE_ALERTS_NAV = { id:"geofence-alerts", icon:"🏠", label:"Idle Alerts" };
const APP_USAGE_NAV = { id:"app-usage", icon:"📱", label:"App Usage" };
const APP_RELEASE_NAV = { id:"app-release", icon:"⬇️", label:"Upload APK" };

export default function Sidebar({ sosAgents }) {
  const { view, setView, sidebarMobileOpen, closeSidebarMobile } = useApp();
  const { user } = useAuth();
  const isSuperAdmin = user?.role === "SUPER_ADMIN";
  const canManageUsers = user?.role === "ADMIN" || user?.role === "SUPER_ADMIN";
  const navItems = [
    ...BASE_NAV,
    ...(isSuperAdmin ? [PRODUCTS_NAV] : []),
    ...(canManageUsers ? [USERS_NAV, APP_ALERTS_NAV, GEOFENCE_ALERTS_NAV, APP_USAGE_NAV, APP_RELEASE_NAV] : []),
  ];

  const handleNavClick = (id) => {
    setView(id);
    closeSidebarMobile();
  };

  return (
    <aside className={`sidebar-nav ${sidebarMobileOpen ? "mobile-open" : ""}`} style={{ ...styles.sidebar, ...(sidebarMobileOpen ? styles.sidebarMobileOpen : {}) }}>
      {/* Logo */}
      <div style={styles.logo}>
        <div style={styles.logoMark}>SLV</div>
        <div>
          <div style={styles.logoText}>SLV ASSOCIATES</div>
          <div style={styles.logoSub}>Admin Console</div>
        </div>
      </div>

      {/* Nav */}
      <nav style={styles.nav}>
        {navItems.map(item => {
          const isActive = view === item.id;
          const badge = item.id === "map" ? sosAgents : 0;
          return (
            <div key={item.id} style={{ ...styles.navItem, ...(isActive ? styles.navActive : {}) }} onClick={() => handleNavClick(item.id)}>
              {isActive && <div style={styles.activeLine} />}
              <span style={{ fontSize:18 }}>{item.icon}</span>
              <span style={{ ...styles.navLabel, color: isActive ? T.text : T.muted }}>{item.label}</span>
              {badge > 0 && <div style={{ ...styles.badge, background: item.id==="map" ? T.sos : T.acc2 }}>{badge}</div>}
            </div>
          );
        })}
      </nav>

      <div style={{ flex:1 }} />

      {/* Bottom */}
      <div style={styles.bottom}>
        <div style={styles.adminCard}>
          <div style={styles.adminAvatar}>
            {(user?.fullName || "AD").split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2)}
          </div>
          <div>
            <div style={{ fontSize:13, fontWeight:600, color:T.text }}>{user?.fullName || "Admin"}</div>
            <div style={{ fontSize:11, color:T.muted }}>{user?.role || "ADMIN"}</div>
          </div>
        </div>
      </div>
    </aside>
  );
}

const styles = {
  sidebar: { width:220, minWidth:220, background:T.s1, borderRight:`1px solid ${T.border}`, display:"flex", flexDirection:"column", padding:"0 0 16px", overflow:"hidden", zIndex:1000 },
  sidebarMobileOpen: { position:"fixed", left:0, top:0, bottom:0, height:"100vh", boxShadow:"4px 0 24px rgba(0,0,0,0.3)" },
  logo: { display:"flex", alignItems:"center", gap:10, padding:"18px 16px 14px", borderBottom:`1px solid ${T.border}` },
  logoMark: { width:36, height:36, background:T.acc, borderRadius:9, display:"flex", alignItems:"center", justifyContent:"center", fontFamily:T.fontMono, fontSize:13, fontWeight:700, color:"#fff", boxShadow:`0 0 20px rgba(124,106,247,0.45)`, flexShrink:0 },
  logoText: { fontSize:12, fontWeight:800, color:T.text, letterSpacing:"1.5px" },
  logoSub: { fontSize:10, color:T.muted, letterSpacing:"0.5px" },
  nav: { padding:"10px 8px", display:"flex", flexDirection:"column", gap:2 },
  navItem: { display:"flex", alignItems:"center", gap:10, padding:"9px 10px", borderRadius:8, cursor:"pointer", transition:"all 0.18s", position:"relative" },
  navActive: { background:"rgba(124,106,247,0.1)" },
  activeLine: { position:"absolute", left:0, top:"20%", bottom:"20%", width:3, background:T.acc, borderRadius:"0 3px 3px 0" },
  navLabel: { fontSize:13, fontWeight:500 },
  badge: { marginLeft:"auto", minWidth:18, height:18, borderRadius:9, display:"flex", alignItems:"center", justifyContent:"center", fontSize:10, fontWeight:700, color:"#fff", padding:"0 5px" },
  bottom: { padding:"0 12px" },
  adminCard: { display:"flex", alignItems:"center", gap:10, padding:"10px 10px", background:T.s2, borderRadius:8, border:`1px solid ${T.border}` },
  adminAvatar: { width:32, height:32, borderRadius:8, background:`linear-gradient(135deg, ${T.acc}, ${T.acc2})`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:12, fontWeight:700, color:"#fff", flexShrink:0 },
};
